import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme';
import { PrimarySelectCardButton, PrimarySelectCardOption } from '../../button';

export type PrimarySelectCardsProps = {
  initialValue?: string;
  onSelect: (value: string) => void;
  options: PrimarySelectCardOption[];
  size: 'small' | 'large';
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Card = styled(PrimarySelectCardButton)<{ size: 'small' | 'large' }>`
  margin-bottom: ${theme.spacings[4].rem};

  ${({ size }) =>
    size === 'small'
      ? `
      max-width: none;
      width: 100%;
    `
      : `margin-right: ${theme.spacings[4].rem};`}
`;

export const PrimarySelectCards: React.FC<PrimarySelectCardsProps> = ({
  initialValue,
  onSelect,
  options,
  size = 'large',
}) => {
  const [selectedOption, setSelectedOption] = useState(
    options.find((opt) => opt.title === initialValue)?.title
  );

  const handleSelect = (value: string) => {
    onSelect(value);
    setSelectedOption(value);
  };

  return (
    <Wrapper>
      {options.map((opt) => (
        <Card
          {...opt}
          key={opt.title}
          onClick={handleSelect}
          selected={opt.title === selectedOption}
          size={size}
        />
      ))}
    </Wrapper>
  );
};
